import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=675c6b62&"
import script from "./ImageGallery.vue?vue&type=script&lang=ts&"
export * from "./ImageGallery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlockImageGallery: require('/tmp/build_71ad00c4/src/components/block/ImageGallery.vue').default})
